var _ellipse, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDisabledConsultation = function SvgDisabledConsultation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 174,
    height: 145,
    viewBox: "0 0 174 145",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.6524,
    cy: 72.6913,
    rx: 71.3718,
    ry: 71.3717,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3367 16.5684L33.1558 17.2196L31.8535 12.8578C30.0564 6.83856 23.7126 3.41195 17.6934 5.20913C11.6741 7.00631 8.24751 13.3501 10.0447 19.3693L11.347 23.7311L9.16611 24.3822C6.76713 25.0985 5.39037 27.6473 6.10664 30.0463L12.6182 51.8551C13.3344 54.2541 15.8833 55.6309 18.2822 54.9146L44.4528 47.1008C46.8518 46.3845 48.2286 43.8357 47.5123 41.4367L41.0008 19.6279C40.2845 17.2289 37.7357 15.8521 35.3367 16.5684ZM28.1118 40.1033C25.7128 40.8195 23.164 39.4428 22.4477 37.0438C21.7314 34.6448 23.1082 32.096 25.5072 31.3797C27.9061 30.6635 30.455 32.0402 31.1712 34.4392C31.8875 36.8382 30.5107 39.387 28.1118 40.1033ZM15.7088 22.4288L14.4065 18.067C13.3255 14.4467 15.3754 10.6518 18.9957 9.5709C22.6159 8.48999 26.4109 10.5398 27.4918 14.1601L28.7941 18.5219L15.7088 22.4288Z",
    fill: "#B8EAD3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2045_746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8714 38.36C33.8714 35.7267 36.1113 33.592 38.8744 33.592H126.428C129.192 33.592 131.431 35.7267 131.431 38.36V45.0353H33.8714V38.36Z",
    fill: "#EAF5EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8714 45.0353H131.431V75.8831V106.731C131.431 109.524 129.192 111.788 126.428 111.788H38.8744C36.1113 111.788 33.8714 109.524 33.8714 106.731V45.0353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.681 50.6451H40.3469C39.3989 50.6451 38.6304 51.3844 38.6304 52.2962C38.6304 53.208 39.3989 53.9472 40.3469 53.9472H61.681C62.6289 53.9472 63.3974 53.208 63.3974 52.2962C63.3974 51.3844 62.6289 50.6451 61.681 50.6451Z",
    fill: "#EAF5EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.123 57.485H43.2895C40.7163 57.485 38.6304 59.4913 38.6304 61.9663C38.6304 64.4412 40.7163 66.4475 43.2895 66.4475H73.2062H103.123C105.696 66.4475 107.782 64.4412 107.782 61.9663C107.782 59.4913 105.696 57.485 103.123 57.485Z",
    fill: "#EAF5EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9347 72.3441H40.3469C39.3989 72.3441 38.6304 73.0833 38.6304 73.995C38.6304 74.9066 39.3989 75.6459 40.3469 75.6459H99.9347C100.883 75.6459 101.652 74.9066 101.652 73.995C101.652 73.0833 100.883 72.3441 99.9347 72.3441Z",
    fill: "#EAF5EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6044 77.7686H40.3469C39.3989 77.7686 38.6304 78.5079 38.6304 79.4195C38.6304 80.3316 39.3989 81.0708 40.3469 81.0708H65.6044C66.5523 81.0708 67.3208 80.3316 67.3208 79.4195C67.3208 78.5079 66.5523 77.7686 65.6044 77.7686Z",
    fill: "#EAF5EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6233 83.1935H40.3469C39.3989 83.1935 38.6304 83.9324 38.6304 84.8444C38.6304 85.7561 39.3989 86.4953 40.3469 86.4953H64.6233C65.5715 86.4953 66.3401 85.7561 66.3401 84.8444C66.3401 83.9324 65.5715 83.1935 64.6233 83.1935Z",
    fill: "#EAF5EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.457 93.5711H41.0826C39.7282 93.5711 38.6304 94.7982 38.6304 96.3114V104.532C38.6304 106.046 39.7282 107.273 41.0826 107.273H124.457C125.811 107.273 126.909 106.046 126.909 104.532V96.3114C126.909 94.7982 125.811 93.5711 124.457 93.5711Z",
    fill: "#EAF5EF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8714 38.36C33.8714 35.7267 36.1113 33.592 38.8744 33.592H126.428C129.192 33.592 131.431 35.7267 131.431 38.36V45.0353H33.8714V38.36Z",
    fill: "url(#paint0_linear_2045_746)",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.681 50.6451H40.3469C39.3989 50.6451 38.6304 51.3844 38.6304 52.2962C38.6304 53.208 39.3989 53.9472 40.3469 53.9472H61.681C62.6289 53.9472 63.3974 53.208 63.3974 52.2962C63.3974 51.3844 62.6289 50.6451 61.681 50.6451Z",
    fill: "url(#paint1_linear_2045_746)",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.123 57.485H43.2895C40.7163 57.485 38.6304 59.4913 38.6304 61.9663C38.6304 64.4412 40.7163 66.4475 43.2895 66.4475H73.2062H103.123C105.696 66.4475 107.782 64.4412 107.782 61.9663C107.782 59.4913 105.696 57.485 103.123 57.485Z",
    fill: "url(#paint2_linear_2045_746)",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9347 72.3441H40.3469C39.3989 72.3441 38.6304 73.0833 38.6304 73.995C38.6304 74.9066 39.3989 75.6459 40.3469 75.6459H99.9347C100.883 75.6459 101.652 74.9066 101.652 73.995C101.652 73.0833 100.883 72.3441 99.9347 72.3441Z",
    fill: "url(#paint3_linear_2045_746)",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6044 77.7686H40.3469C39.3989 77.7686 38.6304 78.5079 38.6304 79.4195C38.6304 80.3316 39.3989 81.0708 40.3469 81.0708H65.6044C66.5523 81.0708 67.3208 80.3316 67.3208 79.4195C67.3208 78.5079 66.5523 77.7686 65.6044 77.7686Z",
    fill: "url(#paint4_linear_2045_746)",
    fillOpacity: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6233 83.1935H40.3469C39.3989 83.1935 38.6304 83.9324 38.6304 84.8444C38.6304 85.7561 39.3989 86.4953 40.3469 86.4953H64.6233C65.5715 86.4953 66.3401 85.7561 66.3401 84.8444C66.3401 83.9324 65.5715 83.1935 64.6233 83.1935Z",
    fill: "url(#paint5_linear_2045_746)",
    fillOpacity: 0.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.457 93.5711H41.0826C39.7282 93.5711 38.6304 94.7982 38.6304 96.3114V104.532C38.6304 106.046 39.7282 107.273 41.0826 107.273H124.457C125.811 107.273 126.909 106.046 126.909 104.532V96.3114C126.909 94.7982 125.811 93.5711 124.457 93.5711Z",
    fill: "url(#paint6_linear_2045_746)",
    fillOpacity: 0.4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.8714,
    y: 33.592,
    width: 97.5597,
    height: 78.1942,
    rx: 5.07139,
    stroke: "#F5F4FB",
    strokeWidth: 0.403406
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M165.901 60.1257L163.369 59.7272L164.166 54.6639C165.266 47.6766 160.488 41.1131 153.501 40.0134C146.513 38.9136 139.95 43.6919 138.85 50.6793L138.053 55.7426L135.521 55.3441C132.737 54.9058 130.099 56.8256 129.661 59.6105L125.676 84.9269C125.238 87.7117 127.158 90.3488 129.943 90.7872L160.323 95.5688C163.107 96.0071 165.745 94.0872 166.183 91.3024L170.168 65.9859C170.606 63.2011 168.686 60.564 165.901 60.1257ZM147.125 80.5197C144.34 80.0814 142.42 77.4443 142.859 74.6595C143.297 71.8747 145.934 69.9548 148.719 70.3931C151.504 70.8314 153.424 73.4685 152.985 76.2534C152.547 79.0382 149.91 80.958 147.125 80.5197ZM143.116 56.5395L143.913 51.4762C144.575 47.2737 148.501 44.4152 152.704 45.0767C156.906 45.7381 159.765 49.6645 159.103 53.867L158.306 58.9303L143.116 56.5395Z",
    fill: "#B8EAD3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2045_746",
    x: 21.966,
    y: 28.3106,
    width: 121.37,
    height: 102.007,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.62399
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.9527
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.54902 0 0 0 0 0.576471 0 0 0 0 0.552941 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2045_746"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.07139
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.84087
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.547271 0 0 0 0 0.577306 0 0 0 0 0.552276 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2045_746",
    result: "effect2_dropShadow_2045_746"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_2045_746",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2045_746",
    x1: 82.6512,
    y1: 33.592,
    x2: 82.6512,
    y2: 111.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2FFF9",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2045_746",
    x1: 82.6512,
    y1: 33.592,
    x2: 82.6512,
    y2: 111.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2FFF9",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2045_746",
    x1: 82.6512,
    y1: 33.592,
    x2: 82.6512,
    y2: 111.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2FFF9",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2045_746",
    x1: 82.6512,
    y1: 33.592,
    x2: 82.6512,
    y2: 111.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2FFF9",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2045_746",
    x1: 82.6512,
    y1: 33.592,
    x2: 82.6512,
    y2: 111.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2FFF9",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2045_746",
    x1: 82.6512,
    y1: 33.592,
    x2: 82.6512,
    y2: 111.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2FFF9",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2045_746",
    x1: 82.6512,
    y1: 33.592,
    x2: 82.6512,
    y2: 111.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2FFF9",
    stopOpacity: 0.7
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDisabledConsultation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "disabled_consultation.569474c50373c6f9d4af72f32c40ef50.svg";